/**
 * This function will render the mini-variants
 */
const inflateMiniVariants = () => {
    window.setInterval(() => {
        const miniVariants = document.querySelectorAll('.mini-variants-container:not(.inflated)');
        miniVariants.forEach((miniVariant) => {
            if (miniVariant.innerHTML == '') {
                miniVariant.classList.add('inflated');
                try {
                    let variantsJSON = miniVariant.getAttribute('data-json-variants');
                    //remove all line breaks from the text
                    variantsJSON = variantsJSON.replace(/(\r\n|\n|\r)/gm, "");

                    let variants = JSON.parse(variantsJSON);
                    let uniqueVariantsOption1 = [];
                    //Process only if multi-size,
                    for (let i = 0; i < variants.length; i++) {
                        if (variants[i].option1.toString().includes('€')) {
                            continue;
                        }
                        let alreadyIn = false;
                        for (let j = 0; j < uniqueVariantsOption1.length; j++) {
                            if (uniqueVariantsOption1[j].option1 === variants[i].option1) {
                                alreadyIn = true;
                            }
                        }
                        if (!alreadyIn) {
                            uniqueVariantsOption1.push(variants[i]);
                        }
                    }

                    //Render the variants
                    for (let i = 0; i < uniqueVariantsOption1.length; i++) {
                        let extraclass = '';
                        if (!uniqueVariantsOption1[i].available) {
                            extraclass = 'unavailable';
                        }
                        if (uniqueVariantsOption1[i].option1.toString().toUpperCase() === 'ÚNICA') {
                            miniVariant.innerHTML += `<span class="mini-variant ${extraclass}">U</span>`;
                        } else {
                            miniVariant.innerHTML += `<span class="mini-variant ${extraclass}">${uniqueVariantsOption1[i].option1}</span>`;
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        });
    }, 1000);
};

inflateMiniVariants();


/**
 * AJAX Add-to-Cart for Compra Rápida size buttons
 */
function thbAddToCart(button) {
    const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = '·';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname
        })
    })
        .then(async res => {
            if (!res.ok) {
                const errorBody = await res.json();
                throw errorBody;
            }
            return res.json();
        })
        .then((response) => {
            button.textContent = '✓';
            button.classList.add('thb-added');

            // Update sections if returned
            if (response.sections) {
                // Update Cart-Drawer
                const drawerElement = document.getElementById('Cart-Drawer');
                if (drawerElement && response.sections['cart-drawer']) {
                    const parsedHTML = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
                    const newContent = parsedHTML.querySelector('.cart-drawer');
                    if (newContent) {
                        const target = drawerElement.classList.contains('cart-drawer') ? drawerElement : drawerElement.querySelector('.cart-drawer');
                        if (target) {
                            target.innerHTML = newContent.innerHTML;
                        }
                    }
                }

                // Update cart count bubbles
                if (response.sections['cart-bubble']) {
                    const parsedHTML = new DOMParser().parseFromString(response.sections['cart-bubble'], 'text/html');
                    const newContent = parsedHTML.querySelector('.thb-item-count');
                    if (newContent) {
                        document.querySelectorAll('.thb-item-count').forEach(el => {
                            el.innerHTML = newContent.innerHTML;
                        });
                    }
                }

                // Re-initialize CartDrawer to bind events to new elements
                if (typeof CartDrawer !== 'undefined') {
                    new CartDrawer();
                }
            }

            // Dispatch event for other theme components
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: response }));

            setTimeout(() => {
                button.textContent = originalText;
                button.disabled = false;
                button.classList.remove('thb-added');
            }, 2200);
        })
        .catch(err => {
            console.error('[thbAddToCart Error]', {
                variantId: variantId,
                error: err
            });
            button.textContent = originalText;
            button.disabled = false;
            alert('Hubo un problema al añadir el producto. Por favor, revisa la consola para más detalles.');
        });
}

/**
 * AJAX Add-to-Cart for Compra Rápida size buttons
 */
function thbAddToCart__(button) {
    const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = '·';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
        .then(async res => {
            if (!res.ok) {
                const errorBody = await res.json();
                throw errorBody;
            }
            return res.json();
        })
        .then(() => {
            button.textContent = '✓';
            button.classList.add('thb-added');

            // Fetch current cart to get updated total item_count
            return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then(res => res.json())
        .then(cart => {
            // Update cart count bubbles
            document.querySelectorAll('.thb-item-count').forEach(el => {
                el.textContent = cart.item_count > 99 ? '*' : cart.item_count;
            });

            // Dispatch event for other theme components
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));

            setTimeout(() => {
                button.textContent = originalText;
                button.disabled = false;
                button.classList.remove('thb-added');
            }, 2200);
        })
        .catch(err => {
            console.error('[thbAddToCart Error]', {
                variantId: variantId,
                error: err
            });
            button.textContent = originalText;
            button.disabled = false;
            alert('Hubo un problema al añadir el producto. Por favor, revisa la consola para más detalles.');
        });
}